<template>
    <div>
        <!-- Modal Cadastro Usuário -->
        <div class="modal fade" id="usuarioApoiadoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Usuário</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-loading v-if="!item" />

                        <template v-else>
                            <div class="alert alert-info d-flex justify-content-between">
                                <div>
                                    {{ item.st_login }}
                                </div>
                                <div>
                                    #{{ item.id_usuario}}
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input 
                                        sizing="sm"
                                        label="Nome" 
                                        required
                                        :validate="validate"
                                        v-model="item.pessoa.st_nome" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6" v-if="item.pessoa.cadastro">
                                    <az-input
                                        sizing="sm"
                                        label="CPF"
                                        type="cpf"
                                        :validate="validate"
                                        v-model="item.pessoa.cadastro.st_cpf" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Data de Nascimento"
                                        type="date"
                                        :validate="validate"
                                        v-model="item.pessoa.cadastro.dt_nascimento" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        label="email"
                                        type="email"
                                        :validate="validate"
                                        :required="item.senha_por_email"
                                        v-model="item.pessoa.cadastro.st_email" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12">
                                    <az-input  
                                        label="Recepção dos Atendimento"
                                        sizing="sm"
                                        type="autocomplete"
                                        optionsMode="aql"
                                        optionsData="id_recepcao"
                                        optionsDisplay="search"
                                        service="recepcaos.index"
                                        :optionsParm="{ filtros: true }"
                                        optionsName="recepcaos.apoiados"
                                        placeholder="Qualquer..."
                                        v-model="item.id_recepcao" />
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualiar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzLoading from '../../util/AzLoading.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            item: null, 
            validate: false, 
        }
    },

    components: { 
        AzInput,
        AzLoading,
        AzSubmit
    },
  
    methods: { 
        abrir(id_usuario) { 
            this.item = null; 
            this.validate = false; 
            $('#usuarioApoiadoModal').modal('show');

            this.$util.load(this, { 
                service: 'usuarios',
                func: 'show',
                parms: { 
                    id: id_usuario,
                    cadastro: true, 
                    edicao: true, 
                },
                loadTo: res => { 
                    if ( res.pessoa && !res.pessoa.cadastro ) { 
                        res.pessoa.cadastro = { 
                            st_cpf: null,
                            dt_nascimento: null
                        };
                    }

                    this.item = res;
                }
            });
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'usuarios',
                func: 'store',
                dados: this.item,
                modal: 'usuarioApoiadoModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh', this.item);
                }
            }); 
        }
    }
}
</script>
